import React, { useEffect, useState } from 'react';
import { getSQLReportData } from '../../services/reports_services';
import { Link } from 'react-router-dom';
import { Icon } from '../../elements';
const ReportsPage = ({ history }) => {
  const [SQLReports, setSQLReports] = useState();

  useEffect(() => {
    getSQLReportData().then(data => {
      setSQLReports(data.results);
    });
  }, []);

  return (
    <div className="p-3 d-flex flex-column justify-center align-center">
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <h4>Relatórios SQL</h4>
        <Link to="/reports/sql/new" className="w-50 btn btn-primary">
          Adicionar Relatório
        </Link>
      </div>
      <div style={gridStyle}>
        {SQLReports &&
          SQLReports.map(report => {
            return (
              <div key={report.id} className="w-100 report-card p-3">
                <div
                  style={{
                    width: '100%',
                    height: '50px',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#ffffff',
                    boxShadow: '0px 9px 25px rgba(0,0,0,0.1)',
                    cursor: 'pointer'
                  }}
                >
                  <h5 style={{ color: '#5f5f5f', textTransform: 'capitalize' }}>
                    <Link
                      style={{ color: '#000000' }}
                      to={`/reports/sql/view/${report.id}`}
                    >
                      {report.name}
                    </Link>
                  </h5>
                  <Icon
                    name="edit"
                    onClick={() => history.push(`/reports/sql/${report.id}`)}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ReportsPage;

const gridStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  gap: '10px',
  marginTop: '20px'
};

const buttonStyle = {
  border: 'none',
  width: '50%',
  height: '30px',
  cursor: 'pointer',
  color: '#ffff',
  borderRadius: '5px',
  backgroundColor: '#499d96',
  textAlign: 'center',
  outline: 'none'
};
